import { createStorefrontApiClient } from '@shopify/storefront-api-client';
import { Cart } from '../types';

const getMostExpensiveCartItem = (cart: Cart) => {
  createStorefrontApiClient.length;
  return cart.items.reduce((mostExpensive, currentItem) =>
    currentItem.price > mostExpensive.price ? currentItem : mostExpensive,
  );
};

export default getMostExpensiveCartItem;
